import { Component } from '@theme/component';

/**
 * A custom element that renders a video background.
 *
 * @typedef {object} Refs
 * @property {HTMLElement[]} videoSources - The video sources.
 * @property {HTMLVideoElement} videoElement - The video element.
 *
 * @extends Component<Refs>
 */
export class VideoBackgroundComponent extends Component {
  requiredRefs = ['videoSources', 'videoElement'];

  connectedCallback() {
    super.connectedCallback();

    const { videoSources, videoElement } = this.refs;

    for (const source of videoSources) {
      const { videoSource } = source.dataset;

      if (videoSource) source.setAttribute('src', videoSource);
    }

    videoElement.load();

    // WOWO: Safari iOS jattaa videon pysaytetyksi, kun lahde asetetaan JS:lla ja
    // load() kutsutaan autoplay-attribuutin kasittelyn jalkeen. Pyydetaan toisto
    // erikseen. Taustavideo on aina muted ja playsinline, joten selain sallii sen.
    const playWhenReady = () => {
      const attempt = videoElement.play();
      if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
    };

    playWhenReady();
    videoElement.addEventListener('loadeddata', playWhenReady, { once: true });

    // Virransaastotilassa selain kieltaytyy, ja silloin video lahtee kayntiin
    // ensimmaisesta kosketuksesta. Ilman tata se jaisi pysyvasti paikalleen.
    document.addEventListener('touchstart', playWhenReady, { once: true, passive: true });
  }
}

if (!customElements.get('video-background-component')) {
  customElements.define('video-background-component', VideoBackgroundComponent);
}
